import { handleApiError } from "@/app/utils/handleApiError";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCategories } from "./categories.service";
import { RejectValueType } from "../redux/redux.types";
import { CategoriesResponse } from "./categories.types";

export const getCategories = createAsyncThunk<
  CategoriesResponse,
  void,
  RejectValueType
>("categories/getCategories", async (_, { rejectWithValue }) => {
  try {
    return await fetchCategories();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
